var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: { title: _vm.title, visible: _vm.dialogFormVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "formRef",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "员工工号：", prop: "empNo" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入员工工号" },
                        model: {
                          value: _vm.form.empNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "empNo", $$v)
                          },
                          expression: "form.empNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "员工姓名：", prop: "empName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入员工姓名" },
                        model: {
                          value: _vm.form.empName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "empName", $$v)
                          },
                          expression: "form.empName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "员工手机号：", prop: "phone" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入员工手机号",
                          maxlength: 11,
                        },
                        model: {
                          value: _vm.form.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "员工微信：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入员工微信" },
                        model: {
                          value: _vm.form.wechat,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "wechat", $$v)
                          },
                          expression: "form.wechat",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "部门：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入部门" },
                        model: {
                          value: _vm.form.dept,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "dept", $$v)
                          },
                          expression: "form.dept",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "职位：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入职位" },
                        model: {
                          value: _vm.form.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "单位：", prop: "companyId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择单位",
                            filterable: "",
                            clearable: "",
                          },
                          on: { change: _vm.handleCompanyChange },
                          model: {
                            value: _vm.form.companyId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "companyId", $$v)
                            },
                            expression: "form.companyId",
                          },
                        },
                        _vm._l(_vm.companyOptions, function (item) {
                          return _c("el-option", {
                            key:
                              item.id ||
                              item.value ||
                              item.companyId ||
                              item.name,
                            attrs: {
                              label:
                                item.name || item.label || item.companyName,
                              value: item.id || item.value || item.companyId,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "标签：" } },
                    [
                      _c(
                        "el-select",
                        {
                          key: _vm.tagSelectKey,
                          staticStyle: { width: "100%" },
                          attrs: {
                            multiple: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            "remote-method": _vm.handleTagSearch,
                            loading: _vm.tagLoading,
                            clearable: "",
                            placeholder: "请输入关键词搜索标签",
                          },
                          model: {
                            value: _vm.form.tagId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "tagId", $$v)
                            },
                            expression: "form.tagId",
                          },
                        },
                        _vm._l(_vm.tagOptions, function (item) {
                          return _c("el-option", {
                            key: item.tagId,
                            attrs: { label: item.tagName, value: item.tagId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("关闭")]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }